import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DesktopNav from "../component/DesktopNav";
import MobileNav from "../component/MobileNav";
import { TopBar, TopBarItem } from "../component/TopBar";
import {
  faFacebookF,
  faLinkedinIn,
  faSquareInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  return (
    <>
      {/* <TopBar>
        <TopBarItem
          label="For Individuals"
          linkRef="/for-individuals"
        ></TopBarItem>

        <TopBarItem
          label="For Bussiness"
          linkRef="/for-individuals"
        ></TopBarItem>

        <TopBarItem
          label="For Univerties"
          linkRef="/for-individuals"
        ></TopBarItem>

        <TopBarItem
          label="For Goverments"
          linkRef="/for-individuals"
        ></TopBarItem>
      </TopBar> */}

      <div className="bg-darken top_bar p-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap">
              <a
                href="tel:18002586884"
                target="_blank"
                className="text-decoration-none text-white"
              >
                1800 2586 884
              </a>

              <span className="header-sep d-inline-block text-white px-2">
                {" "}
                |{" "}
              </span>

              <a
                href="tel:+9196507 27918"
                target="_blank"
                className="text-decoration-none text-white"
              >
                +91 96507 27918
              </a>

              <span className="header-sep d-inline-block text-white px-2">
                {" "}
                |{" "}
              </span>
              <a
                href="mailto:registrar@ialm.academy"
                target="_blank"
                className="text-decoration-none text-white"
              >
                registrar@ialm.academy
              </a>
            </div>

            <div className="col-md-6 d-none d-md-block">
              <div className="d-flex justify-content-center justify-content-md-end">
                {/* <a
                  href="https://twitter.com/IndiaAcademyLaw"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faTwitter} className="" />
                </a> */}

                <a
                  href="https://www.linkedin.com/company/indian-academy-of-law-&-management/?viewAsMember=true&original_referer=http%3A%2F%2Fialm.paybevdev.com%2F"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faLinkedinIn} className="" />
                </a>

                <a
                  href="https://www.facebook.com/profile.php?id=61580930565658"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faFacebookF} className="" />
                </a>

                <a
                  href="https://www.instagram.com/ialm_academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faSquareInstagram} className="" />
                </a>

                <a
                  href="mailto:registrar@ialm.academy"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faEnvelope} className="" />
                </a>
                <a
                  href="https://www.youtube.com/c/IALMcampus"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                >
                  <FontAwesomeIcon icon={faYoutube} className="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DesktopNav />
      <MobileNav />
    </>
  );
}
